module.exports = __webpack_public_path__ + "static/media/yves_legelard.4f2abded.png";